import { useEffect, useState } from 'react';
import { getUserData } from '../utils';

const environment = {
  FRESH_CHAT_WIDGET_TAGS: ['egypt_dashboard'],
  FRESH_CHAT_WIDGET_UUID: 'ec507eca-a794-4bad-96a6-1773aea44aad',
};

export const useLiveChat = () => {
  const profileData = getUserData()
  const {customerId, fullName, email, phone} = profileData
  const [isWidgetsLoaded, setIsWidgetsLoaded] = useState<boolean>();

  const freshChatWidgetInitializer = () => {
    const freshchatScript = document.createElement('script');

    const userInfo = {
      externalId: customerId,
      full_name: fullName,
      email,
      phone 
    };

    const initConfig = {
      config: {
        headerProperty: {
          hideChatButton: true,
        },
      },
      token: '4e93793d-b569-4de2-9d61-9ac6786df61a',
      host: 'https://paymob.freshchat.com',
      tags: environment.FRESH_CHAT_WIDGET_TAGS,
      widgetUuid: environment.FRESH_CHAT_WIDGET_UUID,
      ...userInfo,
    };

    freshchatScript.textContent = `

  function initFreshChat() {
    window?.fcWidget?.init(${JSON.stringify(initConfig)});

  if (window?.fcWidget?.user) {
    window.fcWidget.setExternalId(${JSON.stringify(customerId)});
    window.fcWidget.user.setProperties(${JSON.stringify(userInfo)});   
  }
  }
  function initialize(i, t) {
    var e; i.getElementById(t) ?
      initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0,
        e.src = "https://paymob.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e))
  }
  function initiateCall() { initialize(document, "Freshchat-js-sdk") };
  initiateCall();
  `;

    document.head.appendChild(freshchatScript);

    return freshchatScript;
  };

  useEffect(() => {
    const WINDOW: any = window;

    freshChatWidgetInitializer();

    // Hide freshworks widget trigger btn
    WINDOW?.FreshworksWidget?.('hide', 'launcher');

    return () => {
      WINDOW?.fcWidget?.destroy?.();
      WINDOW?.FreshworksWidget?.('destroy');
    };
  }, []);

  useEffect(() => {
    // this useEffect used to enable the support dropdown items once they're loaded

    const observeWidget = () => {
      // The Freshchat widget iframe is served from paymob.freshchat.com, so its
      // document is cross-origin and unreadable. Its presence in the DOM is the
      // only signal we can — and need to — read here.
      const liveChatWidgetIframe =
        document.querySelectorAll('iframe#fc_widget')[0];

      if (liveChatWidgetIframe && !isWidgetsLoaded) {
        setIsWidgetsLoaded(true);
        domObserver.disconnect();
      }
    };

    const domObserver = new MutationObserver(observeWidget);

    !isWidgetsLoaded &&
      domObserver.observe(document.body, { childList: true, subtree: true });

    return () => domObserver.disconnect();
  }, [isWidgetsLoaded]);
  const chatToggler = () => {
    const WINDOW: any = window;

    WINDOW?.fcWidget.open(), WINDOW?.FreshworksWidget?.('close');
  };
  return { chatToggler };
};
